export const isIos = (ua: string): boolean => {
  return /iPhone|iPad|iPod/i.test(ua);
};

export const isAndroid = (ua: string): boolean => {
  return /android/i.test(ua);
};
